const $inject = ['$q', '$timeout', 'dataService'];

const pointsOfInterestService = function ($q, $timeout, dataService) {
  var service = {};

  service.savePointOfInterest = savePointOfInterest;
  service.deletePointOfInterest = deletePointOfInterest;

  function deletePointOfInterest(item){
    let deferred = $q.defer();

    dataService.patch('PointOfInterests', { IsDeleted: true }, item.id).then(()=>{
      deferred.resolve({message: 'done'});
    });

    return deferred.promise;
  }

  function savePointOfInterest(debtor, item) {
    let deferred = $q.defer();
    let itemCopy = {};

    item.DebtorIdentifier = item.DebtorIdentifier || debtor;
    item.Type = item.Type || "PointOfInterest";

    item.Longitude = parseFloat(item.Longitude);
    item.Latitude = parseFloat(item.Latitude);

    item.Location = {
      coordinates: [item.Longitude, item.Latitude],
      type: "Point"
    };

    angular.copy(item, itemCopy);

    delete itemCopy.marker;
    delete itemCopy.active;

    dataService.post('PointOfInterests', itemCopy).then((data)=>{
      deferred.resolve(data);
    });

    return deferred.promise;
  }

  return service;
};

pointsOfInterestService.$inject = $inject;

export default pointsOfInterestService;



// WEBPACK FOOTER //
// ./src/services/pointsOfInterestService.js